import React from 'react';
import { useLanguage } from '../context/LanguageContext';

// Marcas partner. Añade `logo` (URL del logotipo en blanco/transparente) para
// mostrar la imagen; si no hay logo, se muestra el nombre con estilo.
const BRANDS = [
  { name: 'Control4' },
  { name: 'KNX' },
  { name: 'Lutron' },
  { name: 'Crestron' },
  { name: 'Sonos', logo: 'https://cdn.simpleicons.org/sonos/white' },
  { name: 'Bang & Olufsen' },
  { name: 'Bose', logo: 'https://cdn.simpleicons.org/bose/white' },
  { name: 'Somfy' },
  { name: 'Legrand' },
  { name: 'ABB', logo: 'https://cdn.simpleicons.org/abb/white' },
  { name: 'Philips Hue', logo: 'https://cdn.simpleicons.org/philipshue/white' },
  { name: 'Apple HomeKit', logo: 'https://cdn.simpleicons.org/apple/white' },
];

const HEADINGS = {
  es: {
    badge: 'Partners Tecnológicos',
    title: 'Trabajamos con las mejores marcas',
    subtitle: 'Integramos tecnología líder del sector para garantizar fiabilidad, durabilidad y una experiencia impecable.',
  },
  en: {
    badge: 'Technology Partners',
    title: 'We work with the finest brands',
    subtitle: 'We integrate industry-leading technology to guarantee reliability, durability and a flawless experience.',
  },
};

const BrandTile = ({ brand }) => {
  const [imgError, setImgError] = React.useState(false);
  const showLogo = brand.logo && !imgError;
  return (
    <div className="flex-shrink-0 mx-4 group">
      <div className="glass-card rounded-lg px-10 py-8 flex items-center justify-center min-w-[180px] h-[100px] hover:border-blue-500/50 transition-all duration-300">
        {showLogo ? (
          <img
            src={brand.logo}
            alt={brand.name}
            onError={() => setImgError(true)}
            className="max-h-10 max-w-[130px] object-contain opacity-70 group-hover:opacity-100 transition-opacity duration-300"
            loading="lazy"
          />
        ) : (
          <span className="text-gray-400 group-hover:text-white text-base font-medium tracking-wide uppercase whitespace-nowrap transition-colors duration-300">
            {brand.name}
          </span>
        )}
      </div>
    </div>
  );
};

const BrandsCarousel = ({ background = 'bg-obsidian' }) => {
  const { language } = useLanguage();
  const h = HEADINGS[language] || HEADINGS.es;

  return (
    <section className={`py-24 ${background} border-t border-white/10`} data-testid="brands-carousel">
      <div className="container mx-auto px-6 lg:px-10 mb-14">
        <div className="text-center max-w-2xl mx-auto">
          <p className="overline mb-5">{h.badge}</p>
          <h2 className="font-heading text-3xl md:text-4xl font-light text-white mb-4 tracking-tight">{h.title}</h2>
          <p className="text-white/55 text-base leading-relaxed">{h.subtitle}</p>
        </div>
      </div>
      <div className="marquee-mask overflow-hidden">
        <div className="marquee-track">
          {[...BRANDS, ...BRANDS].map((brand, i) => (
            <BrandTile key={`${brand.name}-${i}`} brand={brand} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default BrandsCarousel;
